export const SETQCEQUIPMENTPARTSLIST = "SETQCEQUIPMENTPARTSLIST";
export const SEQCPROBLEMLIST = "SEQCPROBLEMLIST";
export const SETQCSUBPROBLEMLIST = "SETQCSUBPROBLEMLIST";
export const SETLABELPRINTEQLIST = "SETLABELPRINTEQLIST";
export const SETSCANDETAILS = "SETSCANDETAILS";